import { render } from "./BoxFeedback.vue?vue&type=template&id=7d975683&scoped=true&ts=true"
import script from "./BoxFeedback.vue?vue&type=script&lang=ts"
export * from "./BoxFeedback.vue?vue&type=script&lang=ts"

import "./BoxFeedback.vue?vue&type=style&index=0&id=7d975683&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d975683"]])

export default __exports__